// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DragDropFileUpload Component Styles */

.style_dragDropContainer__y1JUu {
  border-radius: 12px;
  padding: 32px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Default state */
.style_dragDropContainer__y1JUu.style_default__gN8Wr {
  border: 2px dashed var(--border-default);
  background-color: var(--table-row-white);
}

.style_dragDropContainer__y1JUu.style_default__gN8Wr:hover {
  background-color: var(--table-row-alt);
  border-color: var(--border-hover);
}

/* Active drag state */
.style_dragDropContainer__y1JUu.style_dragActive__CJt4o {
  border: 2px dashed var(--border-focus);
  background-color: var(--bg-focus);
}

/* File selected state */
.style_dragDropContainer__y1JUu.style_fileSelected__Z05oY {
  border: 2px dashed var(--border-default);
  background-color: var(--table-row-alt);
}

.style_dragDropContainer__y1JUu.style_fileSelected__Z05oY:hover {
  background-color: var(--table-hover);
  border-color: var(--border-hover);
}

/* Error state */
.style_dragDropContainer__y1JUu.style_error__sw8gN {
  border: 2px dashed var(--border-error);
  background-color: var(--bg-error);
}

.style_dragDropContainer__y1JUu.style_error__sw8gN:hover {
  background-color: var(--bg-error);
  border-color: var(--border-error);
}

/* Hidden file input */
.style_hiddenFileInput__WKdct {
  display: none;
}

/* SelectedFileDisplay Styles */
.style_selectedFileContainer__IsOoE {
  padding: 8px;
  border: 1px solid var(--table-border);
  border-radius: 8px;
  background-color: var(--table-row-alt);
  display: flex;
  align-items: center;
  gap: 16px;
}

.style_filePreviewContainer__d\\+eAC {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid var(--table-border);
}

.style_filePreview__2YWSP {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.style_fileIconContainer__E5c3l {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  background-color: var(--table-header-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.style_fileInfo__wBJb- {
  flex: 1 1;
  min-width: 0;
}

.style_fileName__rYHLP {
  font-weight: 500;
  color: var(--text-heading);
  margin-bottom: 4px;
  word-break: break-all;
  font-size: 0.875rem;
}

.style_fileSize__aPJD3 {
  color: var(--text-secondary);
  font-size: 12px;
}

.style_removeButton__Pc0QS {
  color: var(--text-error);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 4px 8px;
  border-radius: 4px;
  flex-shrink: 0;
  transition: background-color 0.2s ease;
}

.style_removeButton__Pc0QS:hover {
  background-color: var(--bg-error-hover);
  text-decoration: underline;
}

/* DropZoneContent Styles */
.style_uploadIcon__Ju5Zx {
  font-size: 40px;
  margin-bottom: 8px;
}

.style_uploadIcon__Ju5Zx.style_default__gN8Wr {
  color: var(--text-muted);
}

.style_uploadIcon__Ju5Zx.style_dragActive__CJt4o {
  color: var(--border-focus);
}

.style_uploadIcon__Ju5Zx.style_error__sw8gN {
  color: var(--border-error);
}

.style_uploadIcon__Ju5Zx.style_fileSelected__Z05oY {
  margin-bottom: 4px;
}

.style_uploadTitle__Htz5K {
  font-weight: 500;
  margin-bottom: 4px;
  font-size: 1rem;
}

.style_uploadTitle__Htz5K.style_default__gN8Wr {
  color: var(--text-heading);
}

.style_uploadTitle__Htz5K.style_error__sw8gN {
  color: var(--border-error);
}

.style_uploadSubtext__86Efx {
  color: var(--text-secondary);
  font-size: 14px;
}

.style_uploadMaxSize__J3GJp {
  color: var(--text-secondary);
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/DragDropFileUpload/style.module.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB","sourcesContent":["/* DragDropFileUpload Component Styles */\n\n.dragDropContainer {\n  border-radius: 12px;\n  padding: 32px 16px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  height: 140px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Default state */\n.dragDropContainer.default {\n  border: 2px dashed var(--border-default);\n  background-color: var(--table-row-white);\n}\n\n.dragDropContainer.default:hover {\n  background-color: var(--table-row-alt);\n  border-color: var(--border-hover);\n}\n\n/* Active drag state */\n.dragDropContainer.dragActive {\n  border: 2px dashed var(--border-focus);\n  background-color: var(--bg-focus);\n}\n\n/* File selected state */\n.dragDropContainer.fileSelected {\n  border: 2px dashed var(--border-default);\n  background-color: var(--table-row-alt);\n}\n\n.dragDropContainer.fileSelected:hover {\n  background-color: var(--table-hover);\n  border-color: var(--border-hover);\n}\n\n/* Error state */\n.dragDropContainer.error {\n  border: 2px dashed var(--border-error);\n  background-color: var(--bg-error);\n}\n\n.dragDropContainer.error:hover {\n  background-color: var(--bg-error);\n  border-color: var(--border-error);\n}\n\n/* Hidden file input */\n.hiddenFileInput {\n  display: none;\n}\n\n/* SelectedFileDisplay Styles */\n.selectedFileContainer {\n  padding: 8px;\n  border: 1px solid var(--table-border);\n  border-radius: 8px;\n  background-color: var(--table-row-alt);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.filePreviewContainer {\n  width: 50px;\n  height: 50px;\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n  border: 1px solid var(--table-border);\n}\n\n.filePreview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.fileIconContainer {\n  width: 50px;\n  height: 50px;\n  border-radius: 6px;\n  background-color: var(--table-header-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.fileInfo {\n  flex: 1;\n  min-width: 0;\n}\n\n.fileName {\n  font-weight: 500;\n  color: var(--text-heading);\n  margin-bottom: 4px;\n  word-break: break-all;\n  font-size: 0.875rem;\n}\n\n.fileSize {\n  color: var(--text-secondary);\n  font-size: 12px;\n}\n\n.removeButton {\n  color: var(--text-error);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  padding: 4px 8px;\n  border-radius: 4px;\n  flex-shrink: 0;\n  transition: background-color 0.2s ease;\n}\n\n.removeButton:hover {\n  background-color: var(--bg-error-hover);\n  text-decoration: underline;\n}\n\n/* DropZoneContent Styles */\n.uploadIcon {\n  font-size: 40px;\n  margin-bottom: 8px;\n}\n\n.uploadIcon.default {\n  color: var(--text-muted);\n}\n\n.uploadIcon.dragActive {\n  color: var(--border-focus);\n}\n\n.uploadIcon.error {\n  color: var(--border-error);\n}\n\n.uploadIcon.fileSelected {\n  margin-bottom: 4px;\n}\n\n.uploadTitle {\n  font-weight: 500;\n  margin-bottom: 4px;\n  font-size: 1rem;\n}\n\n.uploadTitle.default {\n  color: var(--text-heading);\n}\n\n.uploadTitle.error {\n  color: var(--border-error);\n}\n\n.uploadSubtext {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.uploadMaxSize {\n  color: var(--text-secondary);\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dragDropContainer": `style_dragDropContainer__y1JUu`,
	"default": `style_default__gN8Wr`,
	"dragActive": `style_dragActive__CJt4o`,
	"fileSelected": `style_fileSelected__Z05oY`,
	"error": `style_error__sw8gN`,
	"hiddenFileInput": `style_hiddenFileInput__WKdct`,
	"selectedFileContainer": `style_selectedFileContainer__IsOoE`,
	"filePreviewContainer": `style_filePreviewContainer__d+eAC`,
	"filePreview": `style_filePreview__2YWSP`,
	"fileIconContainer": `style_fileIconContainer__E5c3l`,
	"fileInfo": `style_fileInfo__wBJb-`,
	"fileName": `style_fileName__rYHLP`,
	"fileSize": `style_fileSize__aPJD3`,
	"removeButton": `style_removeButton__Pc0QS`,
	"uploadIcon": `style_uploadIcon__Ju5Zx`,
	"uploadTitle": `style_uploadTitle__Htz5K`,
	"uploadSubtext": `style_uploadSubtext__86Efx`,
	"uploadMaxSize": `style_uploadMaxSize__J3GJp`
};
export default ___CSS_LOADER_EXPORT___;
